<script>
  import PageHero from '$lib/page/Hero.svelte';
  import Back from '$lib/singlePortfolio/Back.svelte';

  export let hero;
  export let back;
</script>

<PageHero {hero} />
<div class="container">
  <Back {back} />
</div>
